export enum CommunicationPreference {
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
  PendingVerification = 'subscriptionVerificationPending'
}

export enum CommunicationPreferenceUpdateOrigin {
  ClientViaExternalApi = 'clientViaExternalApi',
  ClientViaShopify = 'clientViaShopify',
  UserViaSmart = 'userViaSmart',
  UserViaZapier = 'userViaZapier',
  ContactViaLink = 'contactViaLink',
  ContactViaSender = 'contactViaSender',
  KeywordGrowthCampaign = 'keywordGrowthCampaign',
  SmartDueToUnreachableNumber = 'smartDueToUnreachableNumber',
  SmartViaAdminApi = 'smartViaAdminApi',
  ClientViaInbox = 'clientViaInbox',
  SmartByNumberLookup = 'smartByNumberLookup',
  ClientByNumberLookup = 'clientByNumberLookup',
  ClientViaOptOutImport = 'clientViaOptOutImport'
}
